import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DescuentosPerdidasModalComponent } from '../modales/descuentos/descuentos-perdidas-modal/descuentos-perdidas-modal.component';
import { DescuentosExcesosModalComponent } from '../modales/descuentos/descuentos-excesos-modal/descuentos-excesos-modal.component';
import { DescuentosLiquidasModalComponent } from '../modales/descuentos/descuentos-liquidas-modal/descuentos-liquidas-modal.component';
import { DescuentosPagosICAModalComponent } from '../modales/descuentos/descuentos-pagos-ica-modal/descuentos-pagos-ica-modal.component';
import { DescuentosDonacionesModalComponent } from '../modales/descuentos/descuentos-donaciones-moda/descuentos-donaciones-modal.component';
import { DescuentosAFProductivosModalComponent } from '../modales/descuentos/descuentos-af-productivos-modal/descuentos-af-productivos-modal.component';
import { DescuentosRentaAnteriorModalComponent } from '../modales/descuentos/descuentos-renta-anterior-modal/descuentos-renta-anterior-modal.component';
import { DescuentosRetencionModalComponent } from '../modales/descuentos/descuentos-retencion-modal/descuentos-retencion-modal.component';
import { DescuentosSancionModalComponent } from '../modales/descuentos/descuentos-sancion-modal/descuentos-sancion-modal.component';
import { DescuentosSancionExtemporaneaModalComponent } from '../modales/descuentos/descuentos-sancion-extemporanea-modal/descuentos-sancion-extemporanea-modal.component';
import { DDocumento } from '@dian/api-formulario';
import { HandlerComponent, Question } from '../handler-component';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { MessageObservableService } from '../../../../services/message-observable.service';
import { DescuentosRentaPresuntivaModalComponent } from '../modales/descuentos/descuentos-renta-presuntiva-modal/descuentos-renta-presuntiva-modal.component';
import { DescuentosSaldoAFavorModalComponent } from '../modales/descuentos/descuentos-saldo-a-favor/descuentos-saldo-a-favor-modal';

const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo

const questions: Question[] = [
  { question: 'En los años 2018 y anteriores ¿tuvo pérdidas declaradas que quiera compensar?', field: 'cs_id_370', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_" },
  { question: '¿Tuvo renta presuntiva en el 2022?  ', field: 'cs_id_674', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_" },
  { question: '¿Tuvo excesos de renta presuntiva que quiera compensar?', field: 'cs_id_373', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_" },
  { question: '¿Usted tuvo rentas gravables como ingresos por recuperación de deducciones, omisión de activos o pasivos inexistentes e ingresos por comparación patrimonial?', field: 'cs_id_376', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_" },
  { question: 'En el 2022 ¿usted hizo pagos por Impuesto de Industria y Comercio - ICA, que no fueron solicitados como deducción en las rentas de la cédula general?', field: 'cs_id_378', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_" },
  { question: '¿Usted hizo donaciones a Entidades Sin Ánimo de Lucro o a entidades de los artículos 22 y 23 del Estatuto Tributario?  ', field: 'cs_id_380', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_" },
  { question: '¿Usted adquirió, construyó, formó e importó activos fijos reales productivos?  ', field: 'cs_id_432', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_" },
  { question: '¿Usted ha declarado renta en años anteriores? ', field: 'cs_id_433', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_" },
  { question: '¿Le practicaron retenciones en el año gravable a declarar? ', field: 'cs_id_434', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_" },
  { question: '¿Usted tiene saldo a favor en la declaración de renta del año anterior sin solicitud de devolución y/o compensación?', field: 'cs_id_671', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_" },
  { question: '¿Va a registrar sanción por extemporaneidad?', field: 'cs_id_811', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_" },
  { question: '¿Va a registrar sanción por  corrección? ', field: 'cs_id_435', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_" }
];  

@Component({
  selector: 'app-descuentos',
  templateUrl: './descuentos.component.html',
  styleUrls: ['./descuentos.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class DescuentosComponent extends HandlerComponent implements OnInit {

  @Input('model') model: DDocumento = new DDocumento();
  @Output('isCompleted') isCompleted: EventEmitter<boolean> = new EventEmitter<false>();
  @Output('saveModel') saveModel: EventEmitter<boolean> = new EventEmitter<false>();
  constructor(
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    private dialog: MatDialog,
    private _messagesObs: MessageObservableService

  ) {
    super(questions);
  }

  ngOnInit() {
    this.initilizeQuestionsDesdeModelo(this.model);
    this.validateComponentCompleted();

  }

  validateQuestions(id: number) {
    console.log(id);

  }

  private listenMessagesObs() {
    this._messagesObs.getMessages().subscribe(res => {
      if (res.operation === 'model2100Completed') {

      }
    });
  }

  initilizeQuestionsDesdeModelo(model) {
    let hasValue811 = (model.doc.cuerpo.cs_id_811 != undefined && model.doc.cuerpo.cs_id_811 != null);
    for (let i = 0; i < questions.length; i++) {
      switch (i) {
        case 0:
          questions[i].resp = model.doc.cuerpo.cs_id_370;
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_370 != undefined && model.doc.cuerpo.cs_id_370 == "0") || (this.validateModalCompleted(i)));
          if (questions[i].isCompleted || model.doc.cuerpo.cs_id_370 == "1" || hasValue811) { questions[i].show = true; }
          break;
        case 1:
          questions[i].resp = model.doc.cuerpo.cs_id_674;
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_674 != undefined && model.doc.cuerpo.cs_id_674 == "0") || (this.validateModalCompleted(i)));
          if (questions[i].isCompleted || model.doc.cuerpo.cs_id_674 == "1" || hasValue811) { questions[i].show = true; }
          break;
        case 2:
          questions[i].resp = model.doc.cuerpo.cs_id_373;
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_373 != undefined && model.doc.cuerpo.cs_id_373 == "0") || (this.validateModalCompleted(i)));
          if (questions[i].isCompleted || model.doc.cuerpo.cs_id_373 == "1" || hasValue811) { questions[i].show = true; }
          break;
        case 3:
          questions[i].resp = model.doc.cuerpo.cs_id_376;
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_376 != undefined && model.doc.cuerpo.cs_id_376 == "0") || (this.validateModalCompleted(i)));
          if (questions[i].isCompleted || model.doc.cuerpo.cs_id_376 == "1" || hasValue811) { questions[i].show = true; }
          break;
        case 4:
          questions[i].resp = model.doc.cuerpo.cs_id_378;
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_378 != undefined && model.doc.cuerpo.cs_id_378 == "0") || (this.validateModalCompleted(i)));
          if (questions[i].isCompleted || model.doc.cuerpo.cs_id_378 == "1" || hasValue811) { questions[i].show = true; }
          break;
        case 5:
          questions[i].resp = model.doc.cuerpo.cs_id_380;
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_380 != undefined && model.doc.cuerpo.cs_id_380 == "0") || (this.validateModalCompleted(i)));
          if (questions[i].isCompleted || model.doc.cuerpo.cs_id_380 == "1" || hasValue811) { questions[i].show = true; }
          break;
        case 6:
          questions[i].resp = model.doc.cuerpo.cs_id_432;
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_432 != undefined && model.doc.cuerpo.cs_id_432 == "0") || (this.validateModalCompleted(i)));
          if (questions[i].isCompleted || model.doc.cuerpo.cs_id_432 == "1" || hasValue811) { questions[i].show = true; }
          break;
        case 7:
          questions[i].resp = model.doc.cuerpo.cs_id_433;
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_433 != undefined && model.doc.cuerpo.cs_id_433 == "0") || (this.validateModalCompleted(i)));
          if (questions[i].isCompleted || model.doc.cuerpo.cs_id_433 == "1" || hasValue811) { questions[i].show = true; }
          break;
        case 8:
          questions[i].resp = model.doc.cuerpo.cs_id_434;
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_434 != undefined && model.doc.cuerpo.cs_id_434 == "0") || (this.validateModalCompleted(i)));
          if (questions[i].isCompleted || model.doc.cuerpo.cs_id_434 == "1" || hasValue811) { questions[i].show = true; }
          break;
        case 9:
          questions[i].resp = model.doc.cuerpo.cs_id_671;
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_671 != undefined && model.doc.cuerpo.cs_id_671 == "0") || (this.validateModalCompleted(i)));
          if (questions[i].isCompleted || model.doc.cuerpo.cs_id_671 == "1" || hasValue811) { questions[i].show = true; }
          break;
          case 10:
          questions[i].resp = model.doc.cuerpo.cs_id_811;
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_811 != undefined && model.doc.cuerpo.cs_id_811 == "0") || (this.validateModalCompleted(i)));
          if (questions[i].isCompleted || model.doc.cuerpo.cs_id_811 == "1") { questions[i].show = true; }
          break;
        case 11:
          questions[i].resp = model.doc.cuerpo.cs_id_435;
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_435 != undefined && model.doc.cuerpo.cs_id_435 == "0") || (this.validateModalCompleted(i)));
          if (questions[i].isCompleted || model.doc.cuerpo.cs_id_435 == "1") { questions[i].show = true; }
          break;
      }
      this.checkNextQuestion(i);
    }

  }

  openModal(indexQuestionModal: number) {
    const config = {
      minHeight: '80vh',
      minWidth: '80%',
      disableClose: true,
      data: this.model
    };
    switch (indexQuestionModal) {
      case 0:
        let dialog0 = this.dialog.open(
          DescuentosPerdidasModalComponent, config
        );
        dialog0.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });

        dialog0.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 1:
        let dialog1 = this.dialog.open(
          DescuentosRentaPresuntivaModalComponent, config
        );
        dialog1.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });

        dialog1.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 2:
        let dialog2 = this.dialog.open(
          DescuentosExcesosModalComponent, config
        );
        dialog2.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });

        dialog2.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 3:
        let dialog3 = this.dialog.open(
          DescuentosLiquidasModalComponent, config
        );
        dialog3.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });

        dialog3.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 4:
        let dialog4 = this.dialog.open(
          DescuentosPagosICAModalComponent, config
        );
        dialog4.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });

        dialog4.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 5:
        let dialog5 = this.dialog.open(
          DescuentosDonacionesModalComponent, config
        );
        dialog5.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });

        dialog5.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 6:
        let dialog6 = this.dialog.open(
          DescuentosAFProductivosModalComponent, config
        );
        dialog6.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });

        dialog6.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 7:
        let dialog7 = this.dialog.open(
          DescuentosRentaAnteriorModalComponent, config
        );
        dialog7.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });

        dialog7.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 8:
        let dialog8 = this.dialog.open(
          DescuentosRetencionModalComponent, config
        );
        dialog8.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });

        dialog8.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 9:
        let dialog9 = this.dialog.open(
          DescuentosSaldoAFavorModalComponent, config
        );
        dialog9.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });

        dialog9.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
        case 10:
          let dialog10 = this.dialog.open(
            DescuentosSancionExtemporaneaModalComponent, config
          );
          dialog10.componentInstance.saveModel.subscribe(() => {
            this.saveModel.emit(true);
          });
          dialog10.afterClosed().subscribe(data => {
            this.validateModalCompleted(indexQuestionModal);
          });
          break;

      case 11:
        let dialog11 = this.dialog.open(
          DescuentosSancionModalComponent, config
        );
        dialog11.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });

        dialog11.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
    }


  }

  protected validateModalCompleted(indexQuestion: number): boolean {
    let isModalComplete: boolean = false;
    switch (indexQuestion) {
      case 0://Modal 436	Valor stepper flujo pérdidas menores a 2018
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_436, VAL_INDICADOR_COMPLETO)) {
          isModalComplete = true; break;
        }
        break;
      case 1://Modal 677	Valor stepper flujo renta presuntiva
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_677, VAL_INDICADOR_COMPLETO)) {
          isModalComplete = true; break;
        }
        break;
      case 2://Modal 437	Valor stepper flujo excesos renta presuntiva
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_437, VAL_INDICADOR_COMPLETO)) {
          isModalComplete = true; break;
        }
        break;
      case 3://Modal 438	Valor stepper flujo rentas liquidas gravables
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_438, VAL_INDICADOR_COMPLETO)) {
          isModalComplete = true; break;
        }
        break;
      case 4://Modal 439	Valor stepper flujo pagos ICA
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_439, VAL_INDICADOR_COMPLETO)) {
          isModalComplete = true; break;
        }
        break;
      case 5://Modal 440	Valor stepper flujo donaciones
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_440, VAL_INDICADOR_COMPLETO)) {
          isModalComplete = true; break;
        }
        break;
      case 6://Modal 441	Valor stepper flujo activos fijos productivos
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_441, VAL_INDICADOR_COMPLETO)) {
          isModalComplete = true; break;
        }
        break;
      case 7://Modal 442	Valor stepper flujo declaracion renta años anteriores
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_442, VAL_INDICADOR_COMPLETO)) {
          isModalComplete = true; break;
        }
        break;
      case 8://Modal 443	Valor stepper flujo practicaron retenciones
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_443, VAL_INDICADOR_COMPLETO)) {
          isModalComplete = true; break;
        }
        break;
      case 9://Modal 530	Valor stepper flujo saldo a favor
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_530, VAL_INDICADOR_COMPLETO)) {
          isModalComplete = true; break;
        }
        break;
        case 10://Modal 444	Valor stepper flujo sanciones
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_814, VAL_INDICADOR_COMPLETO)) {
          isModalComplete = true; break;
        }
        break;
      case 11://Modal 444	Valor stepper flujo sanciones
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_444, VAL_INDICADOR_COMPLETO)) {
          isModalComplete = true; break;
        }
        break;
      default:
        break;
    }
    if (isModalComplete) {
      questions[indexQuestion].isCompleted = true;
      if (questions.length > indexQuestion + 1) questions[indexQuestion + 1].show = true;//Habilitar visibilidad de la siguiente pregunta
    } else {
      questions[indexQuestion].isCompleted = false;
      //if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = false;
    }
    this.validateComponentCompleted();
    return isModalComplete;
  }

  protected validateHasModalValues(indexQuestion: number): boolean {
    let hasValues: boolean = false;
    switch (indexQuestion) {
      case 0://Modal pérdidas
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_371, "0")) {
          hasValues = true; break;
        }
        break;
      case 1://Modal renta presuntiva
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_675, "0")) {
          hasValues = true; break;
        }
        break;
      case 2://Modal excesos
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_374, "0")) {
          hasValues = true; break;
        }
        break;
      case 3://Modal rentas líquidas gravables
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_377, "0")) {
          hasValues = true; break;
        }
        break;
      case 4://Modal pagos ICA
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_379, "0")) {
          hasValues = true; break;
        }
        break;
      case 5://Modal donaciones
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_381, "0")) {
          hasValues = true; break;
        }
        break;
      case 6://Modal compró af productivos
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_383, "0")) {
          hasValues = true; break;
        }
        break;
      case 7://Modal declaró renta antes
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_385, "0")) {
          hasValues = true; break;
        }
        break;
      case 8://Modal practicaron retención
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_387, "0")) {
          hasValues = true; break;
        }
        break;
      case 9://Modal saldo a favor
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_756, "0")) {
          hasValues = true; break;
        }
        break;
      case 10://Modal sanción
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_812, "0")) {
          hasValues = true; break;
        }
        break;
        case 11://Modal sanción
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_431, "0")) {
          hasValues = true; break;
        }
        break;
      default:
        return false;
    }
    return hasValues;
  }
  protected cleanModalValues(indexQuestionModal: number) {
    switch (indexQuestionModal) {
      case 0:
        this.model.doc.cuerpo.cs_id_371 = "0";
        this.model.doc.cuerpo.cs_id_372 = "0";
        this.model.doc.cuerpo.cs_id_436 = "0";//Indicador de Completo  
        break;
      case 1:
        this.model.doc.cuerpo.cs_id_675 = "0";
        this.model.doc.cuerpo.cs_id_677 = "0";//Indicador de Completo
        break;
      case 2:
        this.model.doc.cuerpo.cs_id_374 = "0";
        this.model.doc.cuerpo.cs_id_437 = "0";//Indicador de Completo
        break;
      case 3:
        this.model.doc.cuerpo.cs_id_377 = "0";
        this.model.doc.cuerpo.cs_id_438 = "0";//Indicador de Completo
        break;
      case 4:
        this.model.doc.cuerpo.cs_id_379 = "0";
        this.model.doc.cuerpo.cs_id_439 = "0";//Indicador de Completo
        break;
      case 5:
        this.model.doc.cuerpo.cs_id_381 = "0";
        this.model.doc.cuerpo.cs_id_382 = "0";
        this.model.doc.cuerpo.cs_id_440 = "0";//Indicador de Completo
        break;
      case 6:
        this.model.doc.cuerpo.cs_id_383 = "0";
        this.model.doc.cuerpo.cs_id_441 = "0";//Indicador de Completo
        break;
      case 7:
        this.model.doc.cuerpo.cs_id_385 = "1";
        this.model.doc.cuerpo.cs_id_386 = "0";
        this.model.doc.cuerpo.cs_id_961 = "0";
        this.model.doc.cuerpo.cs_id_442 = "0";//Indicador de Completo
        break;
      case 8:
        this.model.doc.cuerpo.cs_id_387 = "0";
        this.model.doc.cuerpo.cs_id_443 = "0";//Indicador de Completo
        break;
      case 9:
        this.model.doc.cuerpo.cs_id_756 = "0";
        this.model.doc.cuerpo.cs_id_530 = "0";//Indicador de Completo
        break;
        case 11:
        this.model.doc.cuerpo.cs_id_812 = "0";
        this.model.doc.cuerpo.cs_id_813 = "0";
        this.model.doc.cuerpo.cs_id_814 = "0";//Indicador de Completo
        break;
      case 10:
        this.model.doc.cuerpo.cs_id_431 = "0";
        this.model.doc.cuerpo.cs_id_388 = "0";
        this.model.doc.cuerpo.cs_id_389 = "0";
        this.model.doc.cuerpo.cs_id_390 = "0";
        this.model.doc.cuerpo.cs_id_391 = "0";
        this.model.doc.cuerpo.cs_id_392 = "0";
        this.model.doc.cuerpo.cs_id_430 = "0";
        this.model.doc.cuerpo.cs_id_444 = "0";//Indicador de Completo
        break;
        
    }
    console.log(this.model);
  }

  public validateComponentCompleted(): boolean {
    for (let i = 0; i < questions.length; i++) {
      if (questions[i].isCompleted == false) {
        this.isCompleted.emit(false);
        return false;
      }
    }
    this.isCompleted.emit(true);//Componente completo!
    return true;
  }

  changeValue(data: any, index: number) {
    questions[index].resp = data.value.toString();
    this.model.doc.cuerpo[data.field] = data.value.toString();
    if (this.model.doc.cuerpo[data.field] == "0") {
      if (this.validateHasModalValues(index)) {
        this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
          if (result) {
            questions[index].isCompleted = true;
            this.cleanModalValues(index);
            this.validateComponentCompleted();
            this.saveModel.emit(true);
          } else {
            this.model.doc.cuerpo[data.field] == "";
          }
        });
      } else {
        questions[index].isCompleted = true;
        this.cleanModalValues(index);
        this.saveModel.emit(true);
      }
    } else if (this.model.doc.cuerpo[data.field] == "1") {
      questions[index].isCompleted = false;
      this.validateModalCompleted(index);//Valida antes de abrir el modal por si ya lo había completado para que siga mostrandolo completo
      this.openModal(index);
      this.saveModel.emit(true);

    }
    this.checkNextQuestion(index);
    this.validateComponentCompleted();
    console.log(data);
    console.log(this.model);
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/descuentos/descuentos.component.ts